export enum ExerciseLevel {
  easy = 'easy',
  medium = 'medium',
  hard = 'hard',
}
